import { List } from 'antd';
import { RoutesWithField } from 'app/containers/Task/slice/types';
import React, { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';
import { TextRegular14 } from 'styles/typography';
import CustomListItem from '../../CustomListItem/CustomListItem';
import { ItemsList } from '../../LayoutComponents/LayoutComponents';
import * as S from './RoutesListCard.styled';
import moment from 'moment';
import { getTimeSpent } from 'app/containers/Task/slice/helpers';
import { getRouteDateRangeText } from 'app/containers/Task/pages/TaskListPage/parts/AddRouteToTaskDrawer/AddRouteToTaskDrawer.helpers';

type Props = {
  dropdownElement?: ReactNode;

  onRoutesCheck: (routeIds: number[], coordinates?: any[]) => void;
  onToggleAllRoutes: () => void;
  isAllRoutesChecked: boolean;
  checkedRouteIds: number[];
  groupedRoutes: RoutesWithField[];
  isLoading: boolean;
};

const RoutesListCard: React.FC<Props> = ({
  dropdownElement,

  onToggleAllRoutes,
  onRoutesCheck,
  isAllRoutesChecked,
  checkedRouteIds,
  groupedRoutes,
  isLoading,
}) => {
  const { t } = useTranslation();

  return (
    <ItemsList.Card bordered={false} $maxHeight="100%">
      <S.StyledTopRow justify="space-between" align="middle">
        <div>
          <S.StyledCheckbox
            onClick={onToggleAllRoutes}
            checked={isAllRoutesChecked}
            indeterminate={Boolean(
              !isAllRoutesChecked && checkedRouteIds.length,
            )}
          />
          <TextRegular14>
            {`${t('Common.Displayed', 'Displayed: ')} ${groupedRoutes.length}`}
          </TextRegular14>
        </div>

        {dropdownElement}
      </S.StyledTopRow>
      <List
        loading={isLoading}
        itemLayout="horizontal"
        dataSource={groupedRoutes}
        renderItem={({ routes, field }) => {
          const route = routes[0];

          const routeIds = routes.map(route => route.id);

          const fieldName = field?.properties.field_name || '-';

          const cultureName = field?.properties.culture_name || '-';

          const itemId = `routeItem${route.id}`;
          const isChecked = checkedRouteIds.includes(route.id);
          let secondsSpent = 0;

          routes.forEach(route => {
            const to = moment(route.to);
            const from = moment(route.from);

            const duration = moment.duration(to.diff(from));
            secondsSpent += duration.asSeconds();
          });

          const timeSpent = getTimeSpent(secondsSpent);

          return (
            <CustomListItem
              key={route.id}
              id={itemId}
              isActive={isChecked}
              onClick={() =>
                onRoutesCheck(
                  routeIds,
                  field?.geometry.coordinates || route.geometry.coordinates,
                )
              }
            >
              <S.StyledCheckbox checked={isChecked} />
              <List.Item.Meta
                title={route.gpsVehicle.licensePlate}
                description={
                  <>
                    <S.StyledTransportColorCircle
                      $color={route.gpsVehicle.color}
                    />
                    {fieldName}
                    <br />
                    {`${timeSpent} ${getRouteDateRangeText(
                      route.from,
                      route.from,
                    )}`}
                    <br />
                    {cultureName}
                  </>
                }
              />
            </CustomListItem>
          );
        }}
      />
    </ItemsList.Card>
  );
};

export default RoutesListCard;
